import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { eventDetailData } from "recoil/atoms/events/eventDetailData";
import { EventDetail } from "common/types";

export function useGetEventDetailData() {
  return useRecoilValue(eventDetailData);
}

export function useSetEventDetailData() {
  const reset = useResetRecoilState(eventDetailData);
  const set = useSetRecoilState(eventDetailData);

  return (value: EventDetail | ((prev: EventDetail) => EventDetail)) => {
    reset();
    set(value);
  }
}

export function useResetEventDetailData() {
  return useResetRecoilState(eventDetailData);
}